export default {
  dataModel: {
    types: ['pair:Topic'],
    fieldsMapping: {
      title: 'pair:label'
    }
  },
};
